import { render } from "./CustomHtmlElementProduction.vue.js?vue&type=template&id=5f0f0f34&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomHtmlElementProduction.vue?vue&type=template&id=5f0f0f34&scoped=true"
import script from "./CustomHtmlElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomHtmlElementProduction.vue?vue&type=script&lang=js"
export * from "./CustomHtmlElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomHtmlElementProduction.vue?vue&type=script&lang=js"

import "./CustomHtmlElementProduction.vue.scss?vue&type=style&index=0&id=5f0f0f34&scoped=true&lang=scss!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomHtmlElementProduction.vue?vue&type=style&index=0&id=5f0f0f34&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0f0f34"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/custom-html-element/CustomHtmlElementProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f0f0f34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f0f0f34', __exports__)) {
    api.reload('5f0f0f34', __exports__)
  }
  
  module.hot.accept("./CustomHtmlElementProduction.vue.js?vue&type=template&id=5f0f0f34&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomHtmlElementProduction.vue?vue&type=template&id=5f0f0f34&scoped=true", () => {
    api.rerender('5f0f0f34', render)
  })

}


export default __exports__